import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-heart",
  "use": "icon-heart-usage",
  "viewBox": "0 0 25.001 22.44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25.001 22.44\" id=\"icon-heart\">\r\n  <path id=\"icon-heart_heart-full\" d=\"M21.338,13.127,11.523,23.3,1.708,13.127a5.756,5.756,0,1,1,8.14-8.14l1.675,2.036L13.2,4.989a5.755,5.755,0,0,1,8.14,8.138Z\" transform=\"translate(0.978 -2.301)\" fill=\"none\" stroke=\"#fff\" stroke-width=\"2\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol